import { useEffect } from "react";
import { usePageContext } from "vike-react/usePageContext";

const ScrollToTop = () => {
  const pageContext = usePageContext();
  const { urlPathname: pathname } = pageContext;

  useEffect(() => {
    if (typeof window === "undefined") return;

    const isLanguageSwitch = sessionStorage.getItem("isLanguageSwitch");
    const hash = window.location.hash;

    if (isLanguageSwitch === "true") {
      sessionStorage.removeItem("isLanguageSwitch");
      return;
    }

    if (hash) {
      // If there's a hash, let the browser handle it or scroll to it manually
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        const headerOffset = 100;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - headerOffset;
        window.scrollTo({ top: offsetPosition, behavior: "instant" });
        return;
      }
    }

    // Default behavior: scroll to top
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
